import React, { useEffect, useState, useContext } from 'react';
import styles from './TimedOffers.module.scss';
import { StoreItemsList } from '../StoreItemsList';
import { StoreItemPurchaseModal } from '../StoreItemPurchaseModal/StoreItemPurchaseModal';
import { TokenContext } from '../../Context';
import { fetchStoreItems } from '../../../services/storeServices';

const PAGE_CATEGORY = "Timed Offer";

const TimedOffers = ({ SignVerifyPurchase }) => {
    const [timedOfferItemList, setTimedOfferItemList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [txnHash, setTxnHash] = useState('');
    const ITEMS_PER_PAGE = 12;
    const [messageModal, setMessageModal] = useState({
        show: false,
        completed: false,
        title: '',
        description: '',
        modalType: ''
    });
    const [tokenState] = useContext(TokenContext);

    useEffect(() => {
        fetchTimedOffers();
    }, [tokenState.userId])

    const fetchTimedOffers = async () => {
        setLoading(true);
        let storeItems = await fetchStoreItems(PAGE_CATEGORY, tokenState.userId);
        if (storeItems) {
            setTimedOfferItemList(storeItems);
        }
        setLoading(false);
    }

    const showModalHandler = (show) => {
        setMessageModal({
            ...messageModal,
            show: show,
        })
    }

    const onPurchasePending = (txnHash) => {
        setTxnHash(txnHash);
        setMessageModal({
            show: true,
            completed: false,
            title: 'Order Processing...',
            description: 'It may take 10 mins. You will see your items on your mobile game once the order is completed.'
        });
    }

    const onPurchaseSuccess = () => {
        setMessageModal({
            show: true,
            completed: true,
            title: 'Order Completed!',
            modalType: 'success',
            description: 'Your order has been sent to your CDH game. Have fun!'
        });

        fetchTimedOffers();
    }

    const onPurchaseFail = () => {
        setMessageModal({
            show: true,
            completed: false,
            title: 'Purchase Failed',
            modalType: 'failed',
            description: 'Purchase Item Failed.'
        });
    }

    const handleItemPurchase = async (itemId, itemName, itemPrice) => {
        return SignVerifyPurchase(itemId, itemName, itemPrice, onPurchaseSuccess, onPurchasePending, onPurchaseFail, showModalHandler);
    }

    return (

        <div className={styles.timed_offers_page}>
            {timedOfferItemList && !loading ? (
                timedOfferItemList.length > 0 ?
                    <StoreItemsList
                        itemList={timedOfferItemList}
                        itemsPerPage={ITEMS_PER_PAGE}
                        submitAction={handleItemPurchase}
                    /> :
                    <div className={styles.loading_screen}>
                        <span className={styles.loading_text}>No items to display.</span>
                    </div>
                ) :
                <div className={styles.loading_screen}>
                    <span className={styles.loading_text}>Loading...</span>
                </div>
            }

            <StoreItemPurchaseModal
                content={{
                    show: messageModal.show,
                    showSetter: showModalHandler,
                    completed: messageModal.completed,
                    title: messageModal.title,
                    modalType: messageModal.modalType,
                    txnHash: txnHash,
                    description: messageModal.description,
                    buttonText: 'Done',
                }}
            />
        </div>
    )
}

export { TimedOffers };
